import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";

const links = [
  { label: "Services", id: "offerings" },
  { label: "Work", id: "work" },
  { label: "Pricing", id: "pricing" },
  { label: "Concierge", id: "concierge" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav data-testid="navbar" className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${scrolled ? "glass py-3" : "py-6 bg-transparent"}`}>
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="nav-brand" className="text-left">
          <div className="font-display text-lg sm:text-xl tracking-wide gold-fill leading-none">CROWN ARTISAN</div>
          <div className="text-[9px] tracking-[0.45em] text-white/50 uppercase">Design</div>
        </button>
        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-link-${l.id}`} className="text-xs tracking-[0.22em] uppercase text-white/70 link-gold">
              {l.label}
            </button>
          ))}
        </div>
        <a href="tel:+18179321473" data-testid="nav-call-btn" data-cursor="Call" className="btn-gold rounded-full px-5 py-2.5 text-xs tracking-[0.15em] uppercase font-medium flex items-center gap-2">
          <Phone size={13} /> <span className="hidden sm:inline">817 932 1473</span>
        </a>
      </div>
    </nav>
  );
}
